import { render, staticRenderFns } from "./AthleteCard.vue?vue&type=template&id=ed5f4e66&scoped=true&"
import script from "./AthleteCard.vue?vue&type=script&lang=js&"
export * from "./AthleteCard.vue?vue&type=script&lang=js&"
import style0 from "./AthleteCard.vue?vue&type=style&index=0&id=ed5f4e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5f4e66",
  null
  
)

export default component.exports